<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item>日志列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-table v-loading="baseData.loading" border :data="tableData.data" style="width: 100%">
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="sku" label="sku" width="200"></el-table-column>
            <el-table-column prop="msku" label="msku" width="200"></el-table-column>
            <el-table-column prop="remark" label="remark"></el-table-column>
            <el-table-column prop="addTime" label="时间" width="160"></el-table-column>
        </el-table>
        <div class="pagestyle">
            <el-pagination
              v-model:current-page="searchForm.page"
              v-model:page-size="searchForm.limit"
              layout="sizes, prev, pager, next"
              :total="tableData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading } from 'element-plus'
  const searchForm = reactive({
      limit:10,
      page:1,
  })
  const baseData = reactive({
    loading:false,
  })
  const tableData:any = reactive({
      data:[],
      total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.accessoryApi.get_logs().then((res:any)=>{
      if(res.code==200){
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
      baseData.loading = false
    })
  }

  onMounted(() => {
    getList()
  })
  </script>
  <style lang="less">
  .pagestyle{
    margin: 20px 0;
    text-align: right;
    float: right;
    width: 100%;
  }
  </style>